module.exports = __webpack_public_path__ + "c1af455565b996de371c5f49e357e3c3.svg";